import { Button, Card, Spinner } from 'react-bootstrap';
import { FaWhatsapp } from 'react-icons/fa';
import useIsMedicoExterno from '../../hooks/useIsMedicoExterno';

export default function Footer({
  gravarParcial,
  gravarDefinitivo,
  isSubmitting = false,
  imprimirPdfNormal,
  imprimirPdfTimbrado,
  enviarPorWpp,
  verImagens,
  abrirUploadModal,
  laudo,
}) {
  const isExterno = useIsMedicoExterno();

  if (isExterno) {
    return (
      <Card.Footer className="text-muted d-flex justify-content-center mt-2">
        <div>
          <Button
            onClick={imprimirPdfTimbrado}
            aria-label="Imprimir laudo timbrado"
          >
            Imprimir
          </Button>{' '}
          <Button
            variant="success"
            onClick={verImagens}
            aria-label="Ver imagens do laudo"
          >
            Ver imagens
          </Button>
        </div>
      </Card.Footer>
    );
  }

  return (
    <Card.Footer className="text-muted d-flex justify-content-between mt-2">
      <div>
        <Button
          variant="outline-success"
          onClick={gravarParcial}
          disabled={laudo?.HASH || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Salvando...
            </>
          ) : (
            'Gravar parcial'
          )}
        </Button>{' '}
        <Button
          variant="success"
          onClick={gravarDefinitivo}
          disabled={laudo?.HASH || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Salvando...
            </>
          ) : (
            'Gravar definitivo'
          )}
        </Button>{' '}
        <Button onClick={imprimirPdfNormal} disabled={isSubmitting}>
          Imprimir
        </Button>{' '}
        <Button
          variant="info"
          onClick={imprimirPdfTimbrado}
          disabled={isSubmitting}
        >
          Timbrado
        </Button>{' '}
        <Button variant="secondary" onClick={verImagens} disabled={isSubmitting}>
          Ver imagens
        </Button>{' '}
        <Button
          variant="warning"
          onClick={abrirUploadModal}
          disabled={isSubmitting}
        >
          Anexar
        </Button>{' '}
      </div>
      <div>
        <Button
          variant="outline-success"
          onClick={enviarPorWpp}
          disabled={isSubmitting}
        >
          <FaWhatsapp /> Enviar PDF
        </Button>
      </div>
    </Card.Footer>
  );
}
